export const timeOptions: (number | undefined | null)[] = [1, 5, 30];
